import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft, Home } from "lucide-react";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function CheckoutCancelPage({ onOpenBooking }) {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Pagamento annullato \u2014 MyDigitalAction";
  }, []);

  return (
    <div className="App grain min-h-screen">
      <Navbar onOpenBooking={onOpenBooking} />

      <section className="pt-32 lg:pt-40 pb-16 lg:pb-24 relative">
        <div className="container-max relative">
          <div className="max-w-xl mx-auto text-center py-8">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full border border-white/15 mb-8">
              <XCircle size={36} className="text-white/60" />
            </div>
            <span className="section-label">Pagamento annullato</span>
            <h1 className="font-display text-4xl lg:text-5xl text-white mt-6 leading-tight">
              Nessuna preoccupazione.
            </h1>
            <p className="text-white/70 text-base lg:text-lg mt-6 max-w-md mx-auto">
              Il pagamento \u00e8 stato annullato. Non ti \u00e8 stato addebitato nulla.
              Puoi tornare indietro e completare l'iscrizione quando preferisci.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
              <button type="button" onClick={() => navigate(-1)} className="btn-primary">
                <ArrowLeft size={16} /> Riprova
              </button>
              <Link to="/" className="btn-secondary">
                <Home size={16} /> Torna alla home
              </Link>
            </div>

            <p className="mt-8 text-white/40 text-xs">
              Hai bisogno di assistenza?{" "}
              <button onClick={onOpenBooking} className="underline hover:text-white">
                Parla con un nostro consulente
              </button>
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
